import { searchInsuranceApplicationDetail, insuranceDownloadFile } from "./RmGICRMIAI01/GICRMIAI01Reducer";
import { searchInsuranceApplicationList, updateInsuranceApplicationList } from "./IaGICIAIAS01/GICIAIAS01Reducer";

export const icReducer = {
    searchInsuranceApplicationList,
    updateInsuranceApplicationList,
    searchInsuranceApplicationDetail,
    insuranceDownloadFile
};
